import { render, staticRenderFns } from "./MarketViewLiveEventDetail.vue?vue&type=template&id=aaa68ef6"
import script from "./MarketViewLiveEventDetail.vue?vue&type=script&lang=js"
export * from "./MarketViewLiveEventDetail.vue?vue&type=script&lang=js"
import style0 from "./MarketViewLiveEventDetail.vue?vue&type=style&index=0&id=aaa68ef6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports